export default {
  getUrl (val) {
    var url = ''
    if (val == '1') { // 职称教育
      url = '/continueEdu'
    } else if (val == '2') { // 安全教育
      url = '/byl'
    } else if (val == '3') { // 企业内训
      url = '/entrain'
    } else if (val == '4') { // 党建教育
      url = '/byl'
    } else { // 默认白玉兰
      url = '/byl'
    }
    return url;
  }
}



// WEBPACK FOOTER //
// ./src/utils/orgurl.js